<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 123.103 48.852">
    <g id="Wagon" transform="translate(10739.52 107.105)">
      <path id="Path_87080" data-name="Path 87080"
        d="M42.811,304.882a10.05,10.05,0,1,0,10.051,10.051,10.063,10.063,0,0,0-10.051-10.051m0,17.763a7.712,7.712,0,1,1,7.712-7.712,7.72,7.72,0,0,1-7.712,7.712"
        transform="translate(-10678.712 -383.235)" :fill="themeColor" />
      <path id="Path_87081" data-name="Path 87081"
        d="M13.457,304.882h-.006A10.054,10.054,0,0,0,3.4,314.93a10.078,10.078,0,0,0,10.048,10.051h.006a10.05,10.05,0,0,0,0-20.1m-.006,17.763a7.712,7.712,0,1,1,7.712-7.712,7.72,7.72,0,0,1-7.712,7.712"
        transform="translate(-10733.201 -383.235)" :fill="themeColor" />
      <path id="Path_87082" data-name="Path 87082"
        d="M19.772,312.374l76.357.383c1.611.437,3.23.806,4.819,1.094a45.382,45.382,0,0,1,13.287,4.164c3.8,2.648,5.921,11.077,6.538,15.178a1.171,1.171,0,1,0,2.316-.34c-.706-4.741-3.022-13.542-7.249-16.592A43.68,43.68,0,0,0,101.6,311.6a57.652,57.652,0,0,1-9.189-2.456c-1.891-.826-4.407-2.051-7.238-3.431a191.056,191.056,0,0,0-17.6-7.889c-16.338-5.735-46.783-1.605-50.2-1.111-8.983.2-12.528,14.836-13.148,17.766l-.211.5L.952,319.538a1.123,1.123,0,0,0-.18.44,21.455,21.455,0,0,0,.74,13.627,1.136,1.136,0,0,0,.854.586l.183,0a1.192,1.192,0,0,0,.5-.111,1.172,1.172,0,0,0,.56-1.554,18.762,18.762,0,0,1-.586-11.745l.191-.411,3.042-4.524a1.281,1.281,0,0,0,.183-.44c.029-.157,3.239-16.361,10.951-16.361,3.587-.494,33.736-4.527,49.468.988A178.472,178.472,0,0,1,83.736,307.6l5.593,2.739-69.562-.3a1.167,1.167,0,0,0,.006,2.334"
        transform="translate(-10739.52 -401.921)" :fill="themeColor" />
      <path id="Path_87083" data-name="Path 87083"
        d="M63.252,308.948a1.17,1.17,0,0,0-1.168-1.168h-48.2a1.168,1.168,0,0,0,0,2.337h48.2a1.17,1.17,0,0,0,1.168-1.168"
        transform="translate(-10715.914 -377.855)" :fill="themeColor" />
    </g>
  </svg>


</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
